var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c("div", {
    staticClass: "stock-cases area"
  }, [_c("h4", {
    staticClass: "puhui-M"
  }, [_vm._v("客户案例")]), _c("a-row", {
    attrs: {
      gutter: 24
    }
  }, _vm._l(_vm.casesList, function (item, index) {
    return _c("a-col", {
      key: index,
      attrs: {
        span: 8
      }
    }, [_c("cases-card", {
      attrs: {
        icon: item.icon,
        title: item.title,
        desc: item.desc
      }
    })], 1);
  }), 1)], 1);
};
var staticRenderFns = [];
render._withStripped = true;
export { render, staticRenderFns };